// Styles
import 'normalize.css/normalize.css';
import 'v-autocomplete/dist/v-autocomplete.css';

// Scripts
import $ from 'jquery';
import menus from './components/menus.js';
import helpers from './components/helpers.js';

import VModal from 'vue-js-modal';
import VueLadda from 'vue-ladda';
import vSelect from 'vue-select';
import VeeValidate from 'vee-validate';
import MobileDetect from 'mobile-detect';
import Autocomplete from 'v-autocomplete';

window.$ = window.jQuery = $;
window.MobileDetect = new MobileDetect(window.navigator.userAgent);
window.PubSub = require('pubsub-js');
window.Vue = require('vue');

window.Vue.use(VModal);
window.Vue.use(VeeValidate, { errorBagName: 'vErrors' });
Vue.use(Autocomplete);
window.Vue.component('vue-ladda', VueLadda);
window.Vue.component('v-select', vSelect);

// Others
window.Vue.component('main-menu', require('./components/header/main-menu.vue'));
window.Vue.component('footer-menu', require('./components/header/footer-menu.vue'));
window.Vue.component('categories', require('./components/header/categories.vue'));
window.Vue.component('search-form', require('./components/search-form.vue'));
window.Vue.component('bar-link', require('./components/bar-link'));
window.Vue.component('pwa-popup', require('./components/pwa-popup'));

// // Opt-in
window.Vue.component('opt-in', require('./components/opt-in/opt-in'));
window.Vue.component('modal-opt-in', require('./components/opt-in/modal-opt-in'));

// Custom Modals
window.Vue.component('modal-simple-success', require('./components/custom-modals/modal-simple-success.vue'));
window.Vue.component('modal-offline', require('./components/custom-modals/modal-offline.vue'));
window.Vue.component('modal-offline-tutorial', require('./components/custom-modals/modal-offline-tutorial'));
window.Vue.component('modal-quiz-offline', require('./components/custom-modals/modal-quiz-offline'));
window.Vue.component('modal-ideals-offline', require('./components/custom-modals/modal-ideals-offline'));
window.Vue.component('modal-product-offline', require('./components/custom-modals/modal-product-offline'));
window.Vue.component('modal-terms-and-conditions', require('./components/pages/terms-and-conditions/modal-terms-and-conditions'));
window.Vue.component('modal-privacy-policy', require('./components/pages/privacy-policy/modal-privacy-policy'));

// Modals
window.Vue.component('modal-login', require('./components/auth/modal-login'));
window.Vue.component('modal-register', require('./components/auth/modal-register'));
window.Vue.component('modal-recovery', require('./components/auth/modal-recovery'));

window.Vue.prototype.getItemLink = function(item) {
    if (typeof item.slug != 'undefined') {
        return language_is_default ? ('/product/' + item.slug) : ('/' + language + "/product/" + item.slug);
    } else if (typeof item.link != 'undefined') {
        return ((language_is_default ? ('/' + item.link) : ('/' + language + "" + item.link))).replace("//", "/");
    }
};



async function postData(url = '', data = {}) {
    console.log(document.getElementById("csrf_token_g").content);
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "X-CSRF-TOKEN": document.getElementById("csrf_token_g").content,
        },
        body: JSON.stringify(data)
    });
    return await response.json();
}



window.xx = {};
window.Vue.prototype.getTranslateString = function(original_string = '') {
    //window.xx[original_string] = original_string;

    if (!strings[original_string]) {
        postData("/update_strings", { "lang": language, "string": original_string });
        return original_string;
    } else {
        return (strings[original_string] || original_string); // + "__xxx___";
    }
};



const vues = document.querySelectorAll('.root-app');
const each = Array.prototype.forEach;
each.call(vues, (el) => new Vue({ el }));
window.vues = vues;


$(document).ready(function() {
    menus();
    helpers();
});



// WEBPACK FOOTER //
// ./resources/site/js/app.js